import { manageAPI } from "./index.js";

// Clover OAuth Integration
export const initiateCloverOAuth = async (state, redirectUri) => {
  return (await manageAPI.post("clover/oauth/authorize", {
    state,
    redirect_uri: redirectUri
  })).data;
};

export const completeCloverOAuth = async (code, state, redirectUri, merchant_id) => {
  return (await manageAPI.post("clover/oauth/callback", {
    code,
    state,
    redirect_uri: redirectUri,
    merchant_id: merchant_id
  })).data;
};

export const disconnectClover = async () => {
  return (await manageAPI.post("clover/disconnect")).data;
};

export const getCloverConnectionStatus = async () => {
  return (await manageAPI.get("clover/status")).data;
};

// Additional Clover API functions for data sync
export const syncCloverInventory = async () => {
  return (await manageAPI.post("clover/sync/inventory")).data;
};

export const syncCloverOrders = async () => {
  return (await manageAPI.post("clover/sync/orders")).data;
};

export const syncCloverCustomers = async () => {
  return (await manageAPI.post("clover/sync/customers")).data;
};

export const getCloverSyncStatus = async () => {
  return (await manageAPI.get("clover/sync/status")).data;
};
